import React from 'react';

import type { useTranslation } from '@modernloop/i18n';
import { Chip } from '@mui/material';

import { ResponseStatus } from 'src/generated/mloop-graphql';

type TranslateFn = ReturnType<typeof useTranslation>['t'];

const getResponseStatusNode = (responseStatus: ResponseStatus, t: TranslateFn) => {
  switch (responseStatus) {
    case ResponseStatus.Accepted:
      return (
        <Chip
          data-testid="response-status-node-rsvp-accepted"
          color="success"
          label={t('hiring-dashboard-common:common.rsvp.going')}
        />
      );
    case ResponseStatus.Declined:
      return (
        <Chip
          data-testid="response-status-node-rsvp-declined"
          color="error"
          label={t('hiring-dashboard-common:common.rsvp.declined')}
        />
      );
    case ResponseStatus.Tentative:
      return (
        <Chip data-testid="response-status-node-rsvp-maybe" label={t('hiring-dashboard-common:common.rsvp.maybe')} />
      );
    default:
      return (
        <Chip
          data-testid="response-status-node-rsvp-no-response"
          label={t('hiring-dashboard-common:common.rsvp.noResponse')}
        />
      );
  }
};

export default getResponseStatusNode;
